import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/*eslint-disable*/
import request from '@/utils/request';

/**
 * 获取系统图标列表
 *
 * @param params {Object}
 * @return {Promise<Array<{ name, url }>>}
 */
export function getSystemIcons() {
  return _getSystemIcons.apply(this, arguments);
}
function _getSystemIcons() {
  _getSystemIcons = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var params,
      _yield$request,
      content,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _context.prev = 1;
          _context.next = 4;
          return request({
            url: 'api/sysIcon',
            method: 'get',
            params: _objectSpread(_objectSpread({}, params), {}, {
              page: 0,
              size: 999999
            })
          });
        case 4:
          _yield$request = _context.sent;
          content = _yield$request.content;
          return _context.abrupt("return", content || []);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", []);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return _getSystemIcons.apply(this, arguments);
}
export default {
  getSystemIcons: getSystemIcons
};